import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useViewport } from '../hooks/useViewport';

/**
 * PageTransition — Phase 5.4
 *
 * CSS-only route-change animation. Slides horizontally on phone (iOS-style),
 * fades on tablet/desktop. Honors `prefers-reduced-motion` via the global
 * media query in theme.css — no extra JS gating needed.
 *
 * Cheap implementation: re-key children on pathname change. Mount triggers
 * the keyframe via class.
 */
export default function PageTransition({ children }) {
  const location = useLocation();
  const { isMobile } = useViewport();
  const [key, setKey] = useState(location.pathname);

  useEffect(() => {
    setKey(location.pathname);
  }, [location.pathname]);

  const cls = isMobile ? 'page-transition-slide' : 'page-transition-fade';

  return (
    <div key={key} className={cls} style={{ minHeight: '100%' }}>
      {children}
      <style>{`
        .page-transition-fade {
          animation: ptFade var(--motion-page, 280ms) var(--ease-decelerate, cubic-bezier(0,0,0.2,1));
        }
        .page-transition-slide {
          animation: ptSlide var(--motion-page, 320ms) var(--ease-decelerate, cubic-bezier(0,0,0.2,1));
        }
        @keyframes ptFade {
          from { opacity: 0; transform: translateY(4px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes ptSlide {
          from { opacity: 0.6; transform: translateX(12px); }
          to   { opacity: 1;   transform: translateX(0); }
        }
        [dir="rtl"] .page-transition-slide {
          animation: ptSlideRtl var(--motion-page, 320ms) var(--ease-decelerate, cubic-bezier(0,0,0.2,1));
        }
        @keyframes ptSlideRtl {
          from { opacity: 0.6; transform: translateX(-12px); }
          to   { opacity: 1;   transform: translateX(0); }
        }
      `}</style>
    </div>
  );
}
